// #652 Home page videos (sections/fa-home-shorts.liquid). Vanilla JS.
// - Tile loops play only while on screen (IntersectionObserver); reduced motion = poster only.
// - A tap opens the block's <dialog> with the full video (sound on). Close: X, Esc, backdrop,
//   or the browser back button (one history entry per open viewer).
// - Add to cart posts to /cart/add.js with fetch; assets/custom.js watches that URL and
//   refreshes the header cart count. A failed or slow add never blocks the viewer.
(function () {
  if (window.__faHomeShortsInit) {
    window.__faHomeShortsInit();
    return;
  }

  var ADD_TIMEOUT_MS = 10000;
  var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduceMotion = !!(motionQuery && motionQuery.matches);
  var LATE_POP_MS = 1500; // a popstate this soon after our own history.back() may be that back arriving late
  var backIssuedAt = 0; // when we last called history.back(); 0 = none waiting
  var viewerSeq = 0; // numbers each open, so a history state says which open made it
  var viewerOpenId = 0; // the open now showing
  var visible = new Set();
  var observer = null;
  var openDialog = null; // the dialog now open
  var openTrigger = null; // the tile that opened it
  var historyEntry = false; // true while our history entry is on the stack
  var globalBound = false;

  // #699 Tiles play the 480p file (data-src-480); a failed 480p swaps once to the 720p (data-src-fallback).
  // The src is set only when the tile is on screen and its turn has come: tiles start one at a time,
  // in page order (the next one after the last has played, failed, or START_GAP_MS passed), so the first
  // tile is not slowed by the others. While a viewer is open the unfinished tile downloads are stopped.
  var START_GAP_MS = 1500;
  var starting = null; // the tile now loading its first frames
  var startedAt = 0;
  var pumpTimer = 0;

  function tileDone(video) {
    if (starting === video) starting = null;
    pump();
  }

  function bindTile(video) {
    if (video.__faErrBound) return;
    video.__faErrBound = true;
    video.addEventListener('playing', function () { tileDone(video); });
    video.addEventListener('error', function () {
      var fallback = video.getAttribute('data-src-fallback');
      if (fallback && !video.__faSwapped && video.getAttribute('src') !== fallback) {
        // the 480p failed: the tile now needs the 720p, loaded only when it is allowed to (through the pump)
        video.__faSwapped = true;
        video.__faPending = fallback;
        video.removeAttribute('src');
        video.load();
      }
      tileDone(video);
    });
    video.addEventListener('loadedmetadata', function () {
      var at = video.__faResumeAt;
      if (!at) return;
      try { video.currentTime = at; } catch (e) { return; } // #704 not seekable yet: keep it for the next attach
      // cleared only once the seek reached the target; a seek clamped short by any amount keeps it (#711)
      if (video.currentTime >= at) video.__faResumeAt = 0;
    });
  }

  // The file a tile still has to load: a saved or fallback file, or the 480p if it never started.
  function pendingSrc(v) {
    if (v.getAttribute('src')) return '';
    return v.__faPending || (v.__faStarted ? '' : v.getAttribute('data-src-480') || '');
  }

  function pump() {
    if (reduceMotion || openDialog) return;
    var now = Date.now();
    if (starting && now - startedAt < START_GAP_MS) {
      window.clearTimeout(pumpTimer);
      pumpTimer = window.setTimeout(pump, START_GAP_MS - (now - startedAt) + 20);
      return;
    }
    starting = null;
    var next = null;
    document.querySelectorAll('[data-fa-short-loop]').forEach(function (v) {
      if (!next && visible.has(v) && pendingSrc(v)) next = v;
    });
    if (!next) return;
    bindTile(next);
    starting = next;
    startedAt = now;
    next.setAttribute('src', pendingSrc(next));
    next.__faPending = '';
    next.__faStarted = true;
    var p = next.play();
    if (p && p.catch) p.catch(function () {});
    window.clearTimeout(pumpTimer);
    pumpTimer = window.setTimeout(pump, START_GAP_MS + 20);
  }

  function playLoop(video) {
    if (reduceMotion || openDialog) return;
    if (!video.getAttribute('src')) {
      if (pendingSrc(video)) pump(); // gets its turn in page order
      return;
    }
    bindTile(video);
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  // Give up a tile's download but remember the file; it comes back through the pump when it is visible.
  // Fully downloaded: one buffered range from the start to the end of the file.
  function isWhole(v) {
    var b = v.buffered;
    var d = v.duration;
    return !!(b && b.length === 1 && isFinite(d) && d > 0 && b.start(0) <= 0.1 && b.end(0) >= d - 0.1);
  }

  // Keep a saved resume time until its seek has taken (#704); only then may a source with metadata replace it.
  function rememberTime(v) {
    if (!v.__faResumeAt && v.readyState >= 1 && v.currentTime > 0) v.__faResumeAt = v.currentTime;
  }

  function detachTile(v, onlyUnfinished) {
    var src = v.getAttribute('src');
    if (!src || (onlyUnfinished && isWhole(v))) return;
    v.__faPending = src;
    rememberTime(v);
    v.removeAttribute('src');
    v.load();
  }

  // Viewer open: tiles that are not fully downloaded give up their download (src removed, time kept).
  function stopTiles() {
    document.querySelectorAll('[data-fa-short-loop]').forEach(function (v) {
      v.pause();
      var src = v.getAttribute('src');
      if (!src) return;
      if (isWhole(v)) return;
      v.__faPending = src; // loaded again through the pump after close
      rememberTime(v);
      v.removeAttribute('src');
      v.load();
    });
    starting = null;
  }

  // Tile posters load only when a tile is within 300px of the screen (the section is far below the fold).
  var posterObserver = null;
  function loadPoster(video) {
    var src = video.getAttribute('data-poster');
    if (src && !video.getAttribute('poster')) video.setAttribute('poster', src);
  }
  function watchPosters(root) {
    var loops = root.querySelectorAll('[data-fa-short-loop][data-poster]');
    if (!('IntersectionObserver' in window)) {
      loops.forEach(loadPoster);
      return;
    }
    if (!posterObserver) {
      posterObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadPoster(entry.target);
          posterObserver.unobserve(entry.target);
        });
      }, { rootMargin: '300px 0px' });
    }
    loops.forEach(function (v) { posterObserver.observe(v); });
  }

  function watchLoops(root) {
    var loops = root.querySelectorAll('[data-fa-short-loop]');
    if (reduceMotion) {
      // poster only: never autoplay
      loops.forEach(function (v) { v.removeAttribute('loop'); v.pause(); });
    }
    if (!('IntersectionObserver' in window)) return; // poster stays; nothing autoplays off screen
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visible.add(entry.target);
            playLoop(entry.target);
          } else {
            visible.delete(entry.target);
            entry.target.pause();
            // it left the screen: an unfinished download stops (the file is remembered for the pump)
            detachTile(entry.target, true);
            if (starting === entry.target) { // it held the pump slot: free it
              starting = null;
              window.clearTimeout(pumpTimer);
              pump();
            }
          }
        });
      }, { threshold: 0.4 });
    }
    loops.forEach(function (v) {
      v.muted = true;
      observer.observe(v);
    });
  }

  // The setting can change while the page is open: pause the loops, or resume the ones on screen.
  function onMotionChange() {
    reduceMotion = !!(motionQuery && motionQuery.matches);
    document.querySelectorAll('[data-fa-short-loop]').forEach(function (v) {
      if (reduceMotion) {
        v.removeAttribute('loop');
        v.pause();
        detachTile(v, true); // #705 an unfinished download stops; the poster stays
      } else {
        v.setAttribute('loop', '');
        if (visible.has(v)) playLoop(v);
      }
    });
    if (reduceMotion) { // free the pump slot
      starting = null;
      window.clearTimeout(pumpTimer);
    }
  }

  function setStatus(dialog, text) {
    var el = dialog.querySelector('[data-fa-short-status]');
    if (!el) return;
    el.textContent = '';
    // clear then set so a repeated message is announced again
    window.requestAnimationFrame(function () { el.textContent = text; });
  }

  var ERROR_TEXT = 'Video could not load';

  // The message lives in an always-rendered live region; setting its text announces it.
  function setError(dialog, text) {
    var el = dialog.querySelector('[data-fa-short-error]');
    if (!el) return;
    el.textContent = '';
    if (!text) return;
    window.requestAnimationFrame(function () { el.textContent = text; });
  }

  // Bound before the src is set, so an early failure is never missed.
  function bindFull(dialog, full) {
    if (!full.__faErrBound) {
      full.__faErrBound = true;
      full.addEventListener('error', function () {
        full.setAttribute('data-fa-failed', '');
        setError(dialog, ERROR_TEXT); // the products and the close button keep working
      });
      full.addEventListener('loadeddata', function () {
        full.removeAttribute('data-fa-failed');
        setError(dialog, '');
      });
    }
  }

  // #699 Set the viewer source (the 720p mp4) as early as a pointerdown; safe to call twice.
  var PREPARE_HOLD_MS = 600; // a pointerdown with no open after this long (a scroll) drops the early download
  function prepareFull(dialog) {
    var full = dialog.querySelector('[data-fa-short-full]');
    if (!full) return;
    window.clearTimeout(full.__faPrepTimer);
    bindFull(dialog, full);
    full.preload = 'auto';
    if (!full.getAttribute('src') && full.getAttribute('data-src')) {
      full.setAttribute('src', full.getAttribute('data-src'));
    }
  }

  // The touch turned into a scroll (or never became a tap): nothing may keep downloading.
  function unprepareFull(dialog) {
    var full = dialog.querySelector('[data-fa-short-full]');
    if (!full) return;
    window.clearTimeout(full.__faPrepTimer);
    if (openDialog === dialog || dialog.open) return;
    if (full.getAttribute('src')) full.removeAttribute('src');
    full.preload = 'none';
    full.load();
  }

  function holdPrepared(dialog) {
    var full = dialog.querySelector('[data-fa-short-full]');
    if (full) full.__faPrepTimer = window.setTimeout(function () { unprepareFull(dialog); }, PREPARE_HOLD_MS);
  }

  function openViewer(trigger) {
    var dialog = trigger.closest('.fa-shorts__item').querySelector('[data-fa-short-dialog]');
    if (!dialog || openDialog) return;
    openTrigger = trigger;
    openDialog = dialog;
    stopTiles(); // tiles rest and stop downloading while a viewer is open

    var full = dialog.querySelector('[data-fa-short-full]');
    if (full) {
      loadPoster(full); // a poster attribute is fetched even inside a closed dialog, so it is set on open
      // #714 the tile's poster is already loaded: paint it at once so the viewer is never black while it loads
      var tilePoster = trigger.querySelector('[data-fa-short-loop]');
      tilePoster = tilePoster && tilePoster.getAttribute('poster');
      // #715 escaped, not stripped, so an odd character still points at the same file
      if (tilePoster) full.style.backgroundImage = 'url("' + tilePoster.replace(/\s/g, encodeURIComponent).replace(/["\\]/g, '\\$&') + '")';
    }
    prepareFull(dialog);
    setStatus(dialog, '');
    setError(dialog, '');
    viewerSeq += 1;
    viewerOpenId = viewerSeq;

    try {
      window.history.pushState({ faShort: dialog.id, faOpenId: viewerOpenId }, '');
      historyEntry = true;
    } catch (e) {
      historyEntry = false;
    }

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', ''); // old browser: still closable with the X button
    }

    if (full) {
      if (full.hasAttribute('data-fa-failed')) {
        // it failed on an earlier open and the error event will not fire again: say so, then retry
        setError(dialog, ERROR_TEXT);
        full.load();
      }
      // Reels style: plays straight away on a loop, no player controls on screen.
      setSound(dialog, true);
      var p = full.play();
      if (p && p.catch) {
        p.catch(function (err) {
          // Only a sound block falls back to muted play. A close before playback started
          // (AbortError from pause) must leave the video stopped, and a closed viewer never restarts.
          if (openDialog !== dialog || !err || err.name !== 'NotAllowedError') return;
          // sound blocked by the browser: play muted; a tap on the video turns the sound on
          setSound(dialog, false);
          var q = full.play();
          if (q && q.catch) q.catch(function () {});
        });
      }
    }
    var closeBtn = dialog.querySelector('[data-fa-short-close]');
    if (closeBtn) closeBtn.focus();
  }

  // Sound on or off; the speaker button in the bar shows the state (aria-pressed = sound on).
  function setSound(dialog, on) {
    var full = dialog.querySelector('[data-fa-short-full]');
    if (full) full.muted = !on;
    var btn = dialog.querySelector('[data-fa-short-mute]');
    if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  // Runs for every way of closing (X, Esc, back, backdrop).
  function afterClose(dialog) {
    if (openDialog !== dialog) return;
    var full = dialog.querySelector('[data-fa-short-full]');
    if (full) {
      full.pause();
      if (!isWhole(full)) { // pause() does not cancel the request: drop an unfinished download
        full.removeAttribute('src');
        full.preload = 'none';
        full.load();
      }
    }
    var trigger = openTrigger;
    openDialog = null;
    openTrigger = null;
    if (historyEntry) {
      historyEntry = false;
      backIssuedAt = Date.now(); // its popstate may arrive late; it must not close a viewer opened since
      window.history.back(); // the X or Esc was used: drop our history entry
    }
    visible.forEach(function (v) { playLoop(v); });
    pump();
    if (trigger && typeof trigger.focus === 'function') trigger.focus();
  }

  function closeViewer() {
    if (!openDialog) return;
    var dialog = openDialog;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close(); // fires "close", which calls afterClose
    } else {
      dialog.removeAttribute('open');
      afterClose(dialog);
    }
  }

  function addToCart(button) {
    var dialog = button.closest('[data-fa-short-dialog]');
    if (button.disabled) return;
    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = window.setTimeout(function () { if (controller) controller.abort(); }, ADD_TIMEOUT_MS);

    function done(ok) {
      window.clearTimeout(timer);
      button.disabled = false;
      button.textContent = ok ? 'Added' : label;
      if (ok) {
        window.setTimeout(function () { button.textContent = label; }, 2000);
      }
      setStatus(dialog, ok ? 'Added to cart.' : 'Could not add to cart. Please try again.');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.getAttribute('data-variant-id')), quantity: 1 }] }),
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) { done(response.ok); })
      .catch(function () { done(false); });
  }

  function onClick(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var open = target.closest('[data-fa-short-open]');
    if (open) {
      event.preventDefault();
      openViewer(open);
      return;
    }
    if (target.closest('[data-fa-short-close]')) {
      closeViewer();
      return;
    }
    var add = target.closest('[data-fa-short-add]');
    if (add) {
      addToCart(add);
      return;
    }
    // Tap on the video or the speaker button: sound on or off (like Reels); the video keeps playing
    var soundTarget = target.closest('[data-fa-short-mute], [data-fa-short-full]');
    if (soundTarget) {
      var soundDialog = soundTarget.closest('[data-fa-short-dialog]');
      var v = soundDialog && soundDialog.querySelector('[data-fa-short-full]');
      if (v) {
        setSound(soundDialog, v.muted);
        if (v.paused) {
          var r = v.play();
          if (r && r.catch) r.catch(function () {});
        }
      }
      return;
    }
    // a click on the dark backdrop (the dialog element itself) closes too
    if (target.matches && target.matches('[data-fa-short-dialog]')) closeViewer();
  }

  function bindDialogs(root) {
    root.querySelectorAll('[data-fa-short-dialog]').forEach(function (dialog) {
      if (dialog.__faBound) return;
      dialog.__faBound = true;
      dialog.addEventListener('close', function () { afterClose(dialog); });
    });
  }

  function init() {
    document.querySelectorAll('[data-fa-shorts]').forEach(function (root) {
      if (root.__faShortsReady) return;
      root.__faShortsReady = true;
      watchPosters(root);
      watchLoops(root);
      bindDialogs(root);
    });
    if (globalBound) return;
    globalBound = true;
    document.addEventListener('click', onClick);
    // #699 start fetching the full video as soon as a finger or mouse goes down on a tile
    document.addEventListener('pointerdown', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var tile = target.closest('[data-fa-short-open]');
      var item = tile && tile.closest('.fa-shorts__item');
      var dialog = item && item.querySelector('[data-fa-short-dialog]');
      if (dialog && !openDialog) {
        prepareFull(dialog);
        holdPrepared(dialog);
      }
    });
    document.addEventListener('pointercancel', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var item = target.closest('.fa-shorts__item');
      var dialog = item && item.querySelector('[data-fa-short-dialog]');
      if (dialog) unprepareFull(dialog);
    });
    if (motionQuery) {
      if (motionQuery.addEventListener) motionQuery.addEventListener('change', onMotionChange);
      else if (motionQuery.addListener) motionQuery.addListener(onMotionChange);
    }
    window.addEventListener('popstate', function (event) {
      if (!openDialog) {
        backIssuedAt = 0;
        return;
      }
      var state = event.state;
      if (state && state.faOpenId === viewerOpenId) return; // still on this viewer's own entry
      if (backIssuedAt && Date.now() - backIssuedAt < LATE_POP_MS) {
        // our own back from the previous close, arriving after the viewer was opened again
        backIssuedAt = 0;
        return;
      }
      backIssuedAt = 0;
      historyEntry = false; // the browser already left our entry
      closeViewer();
    });
  }

  window.__faHomeShortsInit = init;
  init();
  document.addEventListener('shopify:section:load', init);
})();
